export enum LocalStorageKeys {
    userSub = 'user_Sub',
    userEmail = 'user_email',
    userName = 'user_name',
    userId = 'user_Id',
    tokenAntigoSistema = 'token',
    id_token = 'id_token'
}